import React from 'react';
import { BannerImageProps } from '../types';
import { StretchBannerImageStyles } from '../styles';

export const BannerImage: React.FC<BannerImageProps> = props => {
  const { pictureUrl } = props;

  return <img src={pictureUrl} className={StretchBannerImageStyles} alt="Реклама" />;
};
